<div
  [ngClass]="{
    'msg-row': true,
    user: sender === user,
    assistant: sender === assistant
  }"
>
  <div class="msg-bubble">
    @if (sender === assistant && text !== workingOnResponseString) {
    <div class="assistant-header">
      <span class="assistant-badge">
        <img
          alt="AI"
          src="assets/images/assistant-msg.png"
          class="assistant-icon"
        />
        Test AI Assistant
      </span>
    </div>
    }

    @if (sender === assistant && text === workingOnResponseString) {
    <div class="working-row">
      <img
        alt="AI"
        src="assets/images/assistant-msg.png"
        class="assistant-icon"
      />
      <span class="working-text">{{ workingOnResponseString }}</span>
    </div>
    } @else {
    <div
      [ngClass]="{
        'margin-content': sender === assistant
      }"
    >
      <markdown
        class="msg-content"
        [data]="displayedText"
      ></markdown>
    </div>
    }

    @if (text !== workingOnResponseString) {
    <div class="msg-time">
      {{ timestamp | date : "MM.dd.yy, hh:mm a" }}
    </div>
    }
  </div>
</div>
